
import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Person from '@material-ui/icons/Person';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { red, yellow, lime } from 'material-ui/colors'
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      // textAlign: 'center',
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch',
      },
  
    },
    menuButton: {
      marginLeft: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
  }));
  const yellowTheme = createMuiTheme({ palette: { primary: yellow } })
  const limeTheme = createMuiTheme({ palette: { primary: lime } })
  const redTheme = createMuiTheme({ palette: { primary: {main: red[200]} } })
export default function Header(props) {
    const classes = useStyles();
    const [UserMenu, setUserMenu] = React.useState(null);
    const handleUserMenu = (event) => {
        setUserMenu(event.currentTarget);
    }
    
    const handleCloseDialog = () => {
        setUserMenu(false);
    }

    const handleLogout = () =>{
      cookies.remove('login_user', { path: '/' });
      window.location.href="/"
    }
    return ([
        <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Club
          </Typography>
          {props.worker && (
          <div>
            {/* <IconButton className={classes.menuButton} color="inherit" aria-label="menu">
            <Person />
            </IconButton> */}
            <Button aria-controls="simple-menu" color="inherit" aria-haspopup="true" onClick={handleUserMenu}>
            <Person />{props.worker.name}
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={UserMenu}
              keepMounted
              open={Boolean(UserMenu)}
              onClose={handleCloseDialog}
            >
              <MenuItem onClick={handleLogout}>התנתק</MenuItem>
              {/* <MenuItem onClick={handleClose}>My account</MenuItem>
              <MenuItem onClick={handleClose}>Logout</MenuItem> */}
            </Menu>
          </div>
          )}
          
        </Toolbar>
        
      </AppBar>
    ])
}